import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2, Sparkles, DatabaseZap, Settings as Cog, CreditCard } from "lucide-react";
import { toast } from "sonner";

export default function OnboardingDialog() {
  const { user, check } = useAuth();
  const [busy, setBusy] = useState(false);
  const open = !!user && user.role !== "admin" && user.demo_prompt_seen === false;

  const finish = async () => { try { await api.post("/auth/seen-onboarding"); } catch (e) { console.error("seen-onboarding failed", e); } await check(); };

  const enableDemo = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/dev/seed-demo");
      toast.success(data.skipped ? "Ukážkové dáta už existujú" : "Ukážkové dáta zapnuté – prezrite si aplikáciu");
      await finish();
    } catch (e) { toast.error("Nepodarilo sa zapnúť ukážkové dáta"); }
    finally { setBusy(false); }
  };

  const skip = async () => { setBusy(true); await finish(); setBusy(false); };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) skip(); }}>
      <DialogContent className="sm:max-w-lg" data-testid="onboarding-dialog">
        <DialogHeader>
          <div className="mx-auto mb-2 grid h-12 w-12 place-items-center rounded-full bg-primary/15"><Sparkles className="h-6 w-6 text-primary" /></div>
          <DialogTitle className="text-center font-heading text-2xl uppercase">Vitajte v APIS Manager</DialogTitle>
          <DialogDescription className="text-center">Rýchle zoznámenie a zapnutie ukážkových dát.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 text-sm text-muted-foreground">
          <p>Spravujte zákazníkov, vozidlá, zákazky a faktúry na jednom mieste. Aby ste si aplikáciu hneď vyskúšali naplno, môžeme vám zapnúť <strong className="text-foreground">ukážkové dáta</strong> – vzoroví zákazníci, vozidlá, zákazky aj faktúry.</p>
          <div className="rounded-lg border border-border bg-background/50 p-3">
            <div className="flex items-start gap-2"><DatabaseZap className="mt-0.5 h-4 w-4 shrink-0 text-primary" /><span>Ukážkové dáta kedykoľvek <strong className="text-foreground">vypnete</strong> v <span className="text-foreground">Nastavenia → Ukážkové dáta → „Odstrániť ukážkové dáta"</span>.</span></div>
            <div className="mt-2 flex items-start gap-2"><CreditCard className="mt-0.5 h-4 w-4 shrink-0 text-primary" /><span>Predplatné a limity overení ŠPZ nájdete v <span className="text-foreground">Nastavenia → Predplatné</span>.</span></div>
          </div>
        </div>
        <div className="mt-2 flex flex-col gap-2 sm:flex-row">
          <Button onClick={enableDemo} disabled={busy} className="min-h-[48px] flex-1 gap-2" data-testid="onboarding-enable-demo">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <DatabaseZap className="h-4 w-4" />} Zapnúť ukážkové dáta</Button>
          <Button variant="outline" onClick={skip} disabled={busy} className="min-h-[48px] flex-1 gap-2" data-testid="onboarding-skip"><Cog className="h-4 w-4" /> Začať s prázdnym účtom</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
